import React from 'react';
import { Button, Icon, Tooltip } from 'antd';
import cn from 'classnames';
import { shutdownAlisaAudioQuery } from '../../../../../shared/api/queries';
import { AlisaAudioControl } from '../../../../../shared/lib/alisaAudioManager';
import { FaRegPlayCircle, FaRegStopCircle } from 'react-icons/fa';
import { GenerateAlisaAudio } from '../../../generateAlisaAudio';
import ToggleAlisaState from '../ToggleAlisaState/ToggleAlisaState';
import styles from './Actions.module.scss';
import ToggleAlisaIvrCompanyState from '../ToggleAlisaIvrCompanyState/ToggleAlisaIvrCompanyState';

const { useShutdownAlisaAudio } = shutdownAlisaAudioQuery;

const renderAudioControlBtn =
  ({ shutdownId, audioData, loading }) =>
  ({ onStop, onPlay, playingShutdownId }) => {
    const isPlaying = playingShutdownId === shutdownId;

    return (
      <Tooltip
        title={isPlaying ? 'Остановить' : 'Воспроизвести текст автоответа'}
      >
        <Button
          icon={loading ? 'loading' : ''}
          className={cn(styles.action, {
            [styles.disabled]: loading,
          })}
          onClick={
            isPlaying
              ? onStop
              : () =>
                  onPlay({
                    shutdownId: shutdownId,
                    audioData: audioData.slice(),
                  })
          }
        >
          {!loading && (
            <Icon component={isPlaying ? FaRegStopCircle : FaRegPlayCircle} />
          )}
        </Button>
      </Tooltip>
    );
  };

const renderGenerateAudioBtn =
  ({ shutdownId, text }) =>
  ({ onClick, loading }) => {
    return (
      <Tooltip title="Сгенерировать аудио автоответа">
        <Button
          className={cn(styles.action, { [styles.disabled]: loading })}
          icon={loading ? 'loading' : 'sound'}
          onClick={() =>
            onClick({
              shutdownId,
              text,
            })
          }
        />
      </Tooltip>
    );
  };

const Actions = ({ shutdown }) => {
  const { data: audioData, isFetching: isAudioFetching } =
    useShutdownAlisaAudio(shutdown.alertId);

  const hasAudioData = isAudioFetching || Boolean(audioData);

  return (
    <div className={styles.root}>
      <ToggleAlisaState shutdown={shutdown} />
      <ToggleAlisaIvrCompanyState shutdown={shutdown} />
      {hasAudioData ? (
        <AlisaAudioControl
          render={renderAudioControlBtn({
            shutdownId: shutdown.alertId,
            audioData,
            loading: isAudioFetching,
          })}
        />
      ) : (
        <GenerateAlisaAudio
          render={renderGenerateAudioBtn({
            shutdownId: shutdown.alertId,
            text: shutdown.alisaText.trim(),
          })}
        />
      )}
    </div>
  );
};

export default Actions;
